module.exports = __webpack_public_path__ + "img/sound.d65df787.svg";